import React, { useEffect } from 'react';
import { OutputBlockData } from '@editorjs/editorjs';

interface TableBlockData {
  withHeadings: boolean;
  stretched: boolean;
  content: string[][];
}

interface TableRendererProps {
  block: OutputBlockData;
  showNextBlock?: () => void;
}

export const TableRenderer: React.FC<TableRendererProps> = ({ block, showNextBlock }) => {
  const { content, withHeadings, stretched } = block.data as TableBlockData;

  // Auto-advance to next block after a short delay for animated content
  useEffect(() => {
    if (showNextBlock) {
      const timer = setTimeout(() => {
        showNextBlock();
      }, 2000); // Show table for 2 seconds before advancing

      return () => clearTimeout(timer);
    }
  }, [showNextBlock]);

  if (!content || !Array.isArray(content) || content.length === 0) {
    return (
      <div className="table-error">
        Invalid table data
      </div>
    );
  }

  const renderCell = (cell: string, rowIndex: number, cellIndex: number) => {
    const cellContent = cell || '&nbsp;';
    
    if (withHeadings && rowIndex === 0) {
      return (
        <th key={cellIndex} className="table-cell table-header">
          {cellContent}
        </th>
      );
    }
    
    return (
      <td key={cellIndex} className="table-cell">
        {cellContent}
      </td>
    );
  };

  return (
    <div className="table-wrapper ">
      {stretched && <div className="table-stretched" />}
      <table className="editorjs-table table-auto">
        <tbody>
          {content.map((row: string[], rowIndex: number) => (
            <tr key={rowIndex}>
              {row.map((cell: string, cellIndex: number) => 
                renderCell(cell, rowIndex, cellIndex)
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableRenderer;
